import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Services = async () => {
  try {
    return await getData(`/website/service/service`);
  } catch (error) {
    console.log(error);
  }
};

export const ServiceId = async (id) => {
  try {
    return await getData(`/website/service/service/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const KeyBenefits = async () => {
  try {
    return await getData(`/website/service/keybenefit`);
  } catch (error) {
    console.log(error);
  }
};

export const ServiceIncludes = async () => {
  try {
    return await getData(`/website/service/serviceinclude`);
  } catch (error) {
    console.log(error);
  }
};